module.exports = __webpack_public_path__ + "img/ejc_web.e740df9c.jpg";